import $ from 'jquery';
import { utils } from '../common/utils';
import { AlertBox } from './alertbox';

export class Newsletter {
    private $newsletter: JQuery<HTMLElement>;
    private $form: JQuery<HTMLElement>;
    private $defaultContainer: JQuery<HTMLElement>;
    private $thanksContainer: JQuery<HTMLElement>;
    private $email: JQuery<HTMLElement>;
    private $button: JQuery<HTMLElement>;
    private apiurl = 'api/newsletter/signup';
    private alertBox: AlertBox;

    constructor(element: HTMLElement | JQuery<HTMLElement>) {
        this.$newsletter = utils.isJquery(element) ? element : $(element);
        this.$form = this.$newsletter.find('form');
        this.$defaultContainer = this.$newsletter.find('.default-container');
        this.$thanksContainer = this.$newsletter.find('.thanks-container');
        this.$email = this.$newsletter.find('input[name=email]');
        this.$button = this.$newsletter.find('button[type=submit]');
        this.alertBox = new AlertBox(this.$newsletter.find('.alert'));
        this.initEvents();
    }

    private initEvents(): void {
        this.$form.on('submit', (evt) => {
            evt.preventDefault();

            const emailVal = this.$email.val() as string;
            if (emailVal !== '') {
                this.$button.prop('disabled', true);

                $.ajax(this.apiurl, {
                    method: 'POST',
                    data: JSON.stringify({ email: emailVal }),
                    contentType: 'application/json; charset=utf-8'
                })
                    .fail((response: JQuery.jqXHR, status: string) => {
                        this.$email.removeClass('is-invalid');
                        const json = response.responseJSON as { error?: string } | undefined;
                        let error = json?.error ?? status;
                        if (error === 'error') {
                            error = 'Ett fel uppstod, vänligen försök igen. Om felet kvarstår kontakta Alzheimerfonden så hjälper vi dig.';
                        }
                        this.alertBox.setText(error);
                        this.alertBox.show();
                    })
                    .done(() => {
                        this.alertBox.hide();
                        this.$defaultContainer.fadeOut(200, () => { this.$thanksContainer.fadeIn(200); });
                    })
                    .always(() => {
                        this.$button.removeAttr('disabled');
                    });
            } else {
                this.$email.addClass('is-invalid');
            }
        });
    }
}
